import { PropuestaBeca } from "@app/_models/propuesta-beca";

export function updatePropuesta(propuestaBeca : PropuestaBeca){
  this.propuesta = propuestaBeca;
  var Monto = '$' + this.propuesta.MontoAprobado.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  this.nuevaPropuesta.get('monto').setValue(Monto);   
}